<template>
  <div>
    <div class="fleet-header">
      <div class="fleet-icon">
        <svg viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <path fill="#444"
              d="M1.5 9.6c1.1 0.7 2.5 1.9 2.5 3.3 0 0.4 0 0.7 0 1.1 0 0 0.1 0 0.1 0s0.9 0 2-1c1 1 2 1 2 1s1 0 2-1c1 1 1.9 1 1.9 1s0.1 0 0.1 0c0-0.3 0-0.7 0-1.1 0-1.4 1.4-2.6 2.5-3.3 0.6-0.4 0.5-1.2-0.2-1.4l-1.4-0.4v-3.8h-1v-1h-3v-2h-2v2h-3v1h-1v3.8l-1.3 0.4c-0.8 0.2-0.8 1-0.2 1.4zM4 5h1v-1h6v1h1v2.5l-3.3-1c-0.5-0.1-1-0.1-1.5 0l-3.2 1v-2.5z">
            </path>
            <path fill="#444"
              d="M14 14c-1 1-2 1-2 1s-1 0-2-1c-1 1-2 1-2 1s-1 0-2-1c-1 1-2 1-2 1s-1 0-2-1c-1 1-2 1-2 1v1h16v-1c0 0-1 0-2-1z">
            </path>
          </g>
        </svg>
      </div>
      <div class="fleet-info">
        <h2 class="fleet-title">Monitoreo de Flota</h2>
        <p class="fleet-subtitle">Estado en tiempo real de embarcaciones</p>
      </div>
      <div class="fleet-stats">
        <div class="stat-item">
          <span class="stat-number">{{ shipsLocation.length }}</span>
          <span class="stat-label">Barcos</span>
        </div>
        <div class="stat-item">
          <span class="stat-number">{{ activeShipsCount }}</span>
          <span class="stat-label">Activos</span>
        </div>
      </div>
    </div>

    <div class="ships-cards">
      <div v-for="ship in sortedShips" :key="ship.id" class="ship-card">
        <div class="ship-card-row">
          <div class="ship-icon small">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
              <path
                d="M6,6H18V9.96L12,8L6,9.96M3.94,19H4C5.6,19 7,18.12 8,17C9,18.12 10.4,19 12,19C13.6,19 15,18.12 16,17C17,18.12 18.4,19 20,19H20.05L21.95,12.31C22.03,12.06 22,11.78 21.89,11.54C21.76,11.3 21.55,11.12 21.29,11.04L20,10.62V6C20,4.89 19.1,4 18,4H15V1H9V4H6A2,2 0 0,0 4,6V10.62L2.71,11.04C2.45,11.12 2.24,11.3 2.11,11.54C2,11.78 1.97,12.06 2.05,12.31M20,21C18.61,21 17.22,20.53 16,19.67C13.56,21.38 10.44,21.38 8,19.67C6.78,20.53 5.39,21 4,21H2V23H4C5.37,23 6.74,22.65 8,22C10.5,23.3 13.5,23.3 16,22C17.26,22.65 18.62,23 20,23H22V21H20Z" />
            </svg>
          </div>
          <div class="ship-card-content">
            <div class="ship-title-row">
              <div class="ship-name">{{ ship.name }}</div>
            </div>

            <div class="status-dot" :class="isRecentUpdate(ship.fecha) ? 'active' : 'inactive'"></div>

          </div>
        </div>
        <div class="ship-card-row">
          <div class="ship-date compact" style="display: flex; flex-direction: column;">
            <span class="date-label">Última actualización:</span>
            <span class="date-value">{{ formatDate(ship.fecha) }}</span>
          </div>
        </div>

        <div class="ship-card-row">
          <svg v-if="getRumbo(ship.rumbo) == 'Norte'" width="24" height="24" viewBox="0 0 24 24" role="img"
            aria-label="Norte" xmlns="http://www.w3.org/2000/svg">
            <title>Norte</title>
            <g transform="rotate(0 12 12)">
              <circle cx="12" cy="12" r="10" fill="none" stroke="rgba(81,98,133,0.12)" stroke-width="1.5" />
              <path d="M12 6 L9.4 11.2 L12 10 L14.6 11.2 Z" fill="rgba(81,98,133,0.9)" />
              <rect x="11.2" y="10" width="1.6" height="5.5" rx="0.8" fill="rgba(81,98,133,0.9)" />
            </g>
          </svg>

          <svg v-if="getRumbo(ship.rumbo) == 'Noreste'" width="24" height="24" viewBox="0 0 24 24" role="img"
            aria-label="Noreste" xmlns="http://www.w3.org/2000/svg">
            <title>Noreste</title>
            <g transform="rotate(45 12 12)">
              <circle cx="12" cy="12" r="10" fill="none" stroke="rgba(81,98,133,0.12)" stroke-width="1.5" />
              <path d="M12 6 L9.4 11.2 L12 10 L14.6 11.2 Z" fill="rgba(81,98,133,0.9)" />
              <rect x="11.2" y="10" width="1.6" height="5.5" rx="0.8" fill="rgba(81,98,133,0.9)" />
            </g>
          </svg>

          <svg v-if="getRumbo(ship.rumbo) == 'Este'" width="24" height="24" viewBox="0 0 24 24" role="img"
            aria-label="Este" xmlns="http://www.w3.org/2000/svg">
            <title>Este</title>
            <g transform="rotate(90 12 12)">
              <circle cx="12" cy="12" r="10" fill="none" stroke="rgba(81,98,133,0.12)" stroke-width="1.5" />
              <path d="M12 6 L9.4 11.2 L12 10 L14.6 11.2 Z" fill="rgba(81,98,133,0.9)" />
              <rect x="11.2" y="10" width="1.6" height="5.5" rx="0.8" fill="rgba(81,98,133,0.9)" />
            </g>
          </svg>

          <svg v-if="getRumbo(ship.rumbo) == 'Sureste'" width="24" height="24" viewBox="0 0 24 24" role="img"
            aria-label="Sureste" xmlns="http://www.w3.org/2000/svg">
            <title>Sureste</title>
            <g transform="rotate(135 12 12)">
              <circle cx="12" cy="12" r="10" fill="none" stroke="rgba(81,98,133,0.12)" stroke-width="1.5" />
              <path d="M12 6 L9.4 11.2 L12 10 L14.6 11.2 Z" fill="rgba(81,98,133,0.9)" />
              <rect x="11.2" y="10" width="1.6" height="5.5" rx="0.8" fill="rgba(81,98,133,0.9)" />
            </g>
          </svg>

          <svg v-if="getRumbo(ship.rumbo) == 'Sur'" width="24" height="24" viewBox="0 0 24 24" role="img"
            aria-label="Sur" xmlns="http://www.w3.org/2000/svg">
            <title>Sur</title>
            <g transform="rotate(180 12 12)">
              <circle cx="12" cy="12" r="10" fill="none" stroke="rgba(81,98,133,0.12)" stroke-width="1.5" />
              <path d="M12 6 L9.4 11.2 L12 10 L14.6 11.2 Z" fill="rgba(81,98,133,0.9)" />
              <rect x="11.2" y="10" width="1.6" height="5.5" rx="0.8" fill="rgba(81,98,133,0.9)" />
            </g>
          </svg>

          <svg v-if="getRumbo(ship.rumbo) == 'Suroeste'" width="24" height="24" viewBox="0 0 24 24" role="img"
            aria-label="Suroeste" xmlns="http://www.w3.org/2000/svg">
            <title>Suroeste</title>
            <g transform="rotate(225 12 12)">
              <circle cx="12" cy="12" r="10" fill="none" stroke="rgba(81,98,133,0.12)" stroke-width="1.5" />
              <path d="M12 6 L9.4 11.2 L12 10 L14.6 11.2 Z" fill="rgba(81,98,133,0.9)" />
              <rect x="11.2" y="10" width="1.6" height="5.5" rx="0.8" fill="rgba(81,98,133,0.9)" />
            </g>
          </svg>

          <svg v-if="getRumbo(ship.rumbo) == 'Oeste'" width="24" height="24" viewBox="0 0 24 24" role="img"
            aria-label="Oeste" xmlns="http://www.w3.org/2000/svg">
            <title>Oeste</title>
            <g transform="rotate(270 12 12)">
              <circle cx="12" cy="12" r="10" fill="none" stroke="rgba(81,98,133,0.12)" stroke-width="1.5" />
              <path d="M12 6 L9.4 11.2 L12 10 L14.6 11.2 Z" fill="rgba(81,98,133,0.9)" />
              <rect x="11.2" y="10" width="1.6" height="5.5" rx="0.8" fill="rgba(81,98,133,0.9)" />
            </g>
          </svg>

          <svg v-if="getRumbo(ship.rumbo) == 'Noroeste'" width="24" height="24" viewBox="0 0 24 24" role="img"
            aria-label="Noroeste" xmlns="http://www.w3.org/2000/svg">
            <title>Noroeste</title>
            <g transform="rotate(315 12 12)">
              <circle cx="12" cy="12" r="10" fill="none" stroke="rgba(81,98,133,0.12)" stroke-width="1.5" />
              <path d="M12 6 L9.4 11.2 L12 10 L14.6 11.2 Z" fill="rgba(81,98,133,0.9)" />
              <rect x="11.2" y="10" width="1.6" height="5.5" rx="0.8" fill="rgba(81,98,133,0.9)" />
            </g>
          </svg>








          <span class="date-value">{{ getRumbo(ship.rumbo) }}</span>
        </div>
      </div>
    </div>
    <label>
      <input type="checkbox" v-model="showLabels" />
      Mostrar etiquetas
    </label>
    <BarcoMap :ships="ships" :showLabels="showLabels" />
  </div>
</template>

<script>
import BarcoMap from '@/components/track/BarcoMap.vue'
import axios from 'axios'
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"

dayjs.extend(utc)
dayjs.extend(timezone)

export default {
  components: { BarcoMap },
  data() {
    return {
      ships: [],
      apiActiveShips: [],
      shipsLocation: [],
      showLabels: true,
      locationInterval: null,
      isDestroyed: false, // Flag para evitar operaciones cuando el componente está destruido
      isRequestInProgress: false // Flag para evitar peticiones simultáneas
    }
  },
  mounted() {
    this.isDestroyed = false;
    // 1. Obtener barcos activos al cargar la página
    this.initializeTrackingFlow();
  },
  beforeDestroy() {
    this.isDestroyed = true;
    this.cleanup();
  },
  computed: {
    sortedShips() {
      return [...this.shipsLocation].sort((a, b) => a.name.localeCompare(b.name));
    },
    activeShipsCount() {
      return this.shipsLocation.filter(ship => this.isRecentUpdate(ship.fecha)).length;
    }
  },
  methods: {
    cleanup() {
      this.isDestroyed = true;
      if (this.locationInterval) {
        clearInterval(this.locationInterval);
        this.locationInterval = null;
      }
    },
    
    // Versión NO async para evitar race conditions
    initializeTrackingFlow() {
      if (this.isDestroyed) return;
      
      // 1. Obtener barcos activos primero
      this.getActiveShips()
        .then(() => {
          if (this.isDestroyed) return;
          
          // 2. Obtener ubicaciones inmediatamente
          return this.obtainLocationShips();
        })
        .then(() => {
          if (this.isDestroyed) return;
          
          // 3. Configurar intervalo con verificación estricta
          this.locationInterval = setInterval(() => {
            if (this.isDestroyed || this.isRequestInProgress) {
              return;
            }
            this.obtainLocationShips();
          }, 5 * 60 * 1000); // 5 minutos
        })
        .catch(error => {
          console.error('Error en el flujo de trackeo:', error);
        });
    },
    getActiveShips() {
      if (this.isDestroyed) {
        return Promise.resolve([]);
      }
      
      return axios.get('https://gateway.marimsys.cl/API/VMS/genobtenermoviles', {
        auth: {
          username: process.env.VUE_APP_USER_API_MARIMSYS,
          password: process.env.VUE_APP_PASSWORD_API_MARIMSYS
        }
      })
        .then(response => {
          if (this.isDestroyed) {
            return [];
          }

          const barcos = response.data.Moviles || [];
          this.apiActiveShips = barcos.map(barco => ({
            id: barco.IdentificadorMovil,
            name: barco.DescripcionMovil.split('[')[0].trim(),
          }));

          return this.apiActiveShips;
        })
        .catch(error => {
          if (this.isDestroyed) {
            return [];
          }
          console.error('Error fetching active ships:', error);
          throw error;
        })
    },
    // Versión secuencial para evitar sobrecarga de la API
    obtainLocationShips() {
      if (this.isDestroyed) {
        return Promise.resolve();
      }
      
      if (this.isRequestInProgress) {
        return Promise.resolve();
      }
      
      this.isRequestInProgress = true;

      // Procesar barcos uno por uno secuencialmente
      return this.processShipsSequentially(0)
        .finally(() => {
          this.isRequestInProgress = false;
        });
    },

    // Función recursiva para procesar barcos uno por uno
    processShipsSequentially(index) {
      // Si llegamos al final o el componente fue destruido, terminar
      if (index >= this.apiActiveShips.length || this.isDestroyed) {
        return Promise.resolve();
      }

      const ship = this.apiActiveShips[index];
      
      return axios.get(
        `https://gateway.marimsys.cl/API/VMS/Posicion?identificador=${ship.id}`,
        {
          auth: {
            username: process.env.VUE_APP_USER_API_MARIMSYS,
            password: process.env.VUE_APP_PASSWORD_API_MARIMSYS
          }
        }
      )
      .then(response => {
        // Verificar si el componente sigue activo después de la petición
        if (this.isDestroyed) {
          return Promise.resolve();
        }

        const posicion = response.data.Posicion;
        if (posicion) {
          const existingShip = this.shipsLocation.find(sh => sh.id == posicion.IdentificadorMovil);
          
          if (existingShip) {
            // Actualizar barco existente
            existingShip.lat = posicion.Latitud;
            existingShip.lng = posicion.Longitud;
            existingShip.fecha = posicion.FechaReporte;
            existingShip.velocidad = posicion.Velocidad;
            existingShip.rumbo = posicion.Rumbo;
          } else {
            // Agregar nuevo barco
            this.shipsLocation.push({
              id: posicion.IdentificadorMovil,
              name: ship.name.toUpperCase(),
              lat: posicion.Latitud,
              lng: posicion.Longitud,
              fecha: posicion.FechaReporte,
              velocidad: posicion.Velocidad,
              rumbo: posicion.Rumbo
            });
          }

          // Actualizar el mapa después de cada barco (carga progresiva)
          if (!this.isDestroyed) {
            this.updateShipsFromLocation();
          }
        }

        // Procesar el siguiente barco si el componente sigue activo
        if (!this.isDestroyed) {
          return this.processShipsSequentially(index + 1);
        }
        
        return Promise.resolve();
      })
      .catch(error => {
        if (this.isDestroyed) {
          return Promise.resolve();
        }
        
        console.error(`Error obteniendo ubicación para ${ship.id}:`, error);
        
        // Continuar con el siguiente barco aunque haya error
        if (!this.isDestroyed) {
          return this.processShipsSequentially(index + 1);
        }
        
        return Promise.resolve();
      });
    },
    updateShipsFromLocation() {
      // Convierte los datos de shipsLocation al formato que usa el mapa
      this.ships = this.shipsLocation.map(ship => ({
        id: ship.id,
        name: ship.name,
        lat: ship.lat,
        lng: ship.lng,
        prevLat: ship.lat,
        prevLng: ship.lng
      }));
    },
    formatDate(utcString) {
      if (!utcString) return 'Sin datos';
      let d
      if (utcString.endsWith("Z")) {
        // Caso UTC explícito
        d = dayjs.utc(utcString)
      } else {
        // Caso sin "Z" (lo interpretamos como UTC igualmente para mantener coherencia)
        d = dayjs.utc(utcString)
      }

      return d.tz("America/Santiago").format("DD-MM-YYYY HH:mm:ss");
    },
    getRumbo(degrees) {
      const directions = [
        "Norte",
        "Noreste",
        "Este",
        "Sureste",
        "Sur",
        "Suroeste",
        "Oeste",
        "Noroeste"
      ];

      // Normalizar entre 0 y 360
      const normalized = (degrees % 360 + 360) % 360;

      // Calcular índice del arreglo
      const index = Math.round(normalized / 45) % 8;

      return directions[index];
    },
    isRecentUpdate(fechaString) {
      if (!fechaString) return false;
      const fecha = new Date(fechaString);
      const ahora = new Date();
      const diferencia = ahora - fecha;
      const horasTranscurridas = diferencia / (1000 * 60 * 60);
      return horasTranscurridas <= 2; // Considera activo si fue actualizado en las últimas 2 horas
    },
  }
}
</script>
<style>
.fleet-header {
  display: flex;
  align-items: center;
  gap: 20px;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.95) 0%, rgba(240, 248, 255, 0.9) 100%);
  border: 1px solid rgba(81, 98, 133, 0.2);
  border-radius: 20px;
  backdrop-filter: blur(10px);
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(81, 98, 133, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.5);
  padding: 24px;
  margin-bottom: 30px;
  position: relative;
  overflow: hidden;
}

.fleet-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #4a90e2 0%, #357abd 50%, #2c5f87 100%);
}

.fleet-icon {
  width: 64px;
  height: 64px;
  padding: 16px;
  background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
  flex-shrink: 0;
}

.fleet-icon svg {
  width: 32px;
  height: 32px;
  fill: white;
}

.fleet-info {
  flex: 1;
  min-width: 0;
}

.fleet-title {
  font-size: 28px;
  font-weight: 700;
  color: #1a365d;
  margin: 0 0 4px 0;
  line-height: 1.2;
}

.fleet-subtitle {
  font-size: 16px;
  color: #64748b;
  margin: 0;
  font-weight: 500;
}

.fleet-stats {
  display: flex;
  gap: 24px;
  flex-shrink: 0;
}

.stat-item {
  text-align: center;
  padding: 12px 16px;
  background: rgba(74, 144, 226, 0.1);
  border-radius: 12px;
  border: 1px solid rgba(74, 144, 226, 0.2);
  min-width: 80px;
}

.stat-number {
  display: block;
  font-size: 24px;
  font-weight: 700;
  color: #1a365d;
  line-height: 1;
}

.stat-label {
  display: block;
  font-size: 12px;
  color: #64748b;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 4px;
}

.ships-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 20px;
  margin-bottom: 24px;
}

.ship-card {
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.95) 0%, rgba(240, 248, 255, 0.9) 100%);
  border: 1px solid rgba(81, 98, 133, 0.2);
  border-radius: 16px;
  backdrop-filter: blur(10px);
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(81, 98, 133, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.5);
  padding: 24px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 6px;
  /* ajusta el valor a lo que necesites */
}

.ship-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #4a90e2 0%, #357abd 50%, #2c5f87 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.ship-card:hover {
  /* transform: translateY(-4px); */
  box-shadow:
    0 20px 40px rgba(0, 0, 0, 0.15),
    0 8px 24px rgba(81, 98, 133, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

.ship-card:hover::before {
  opacity: 1;
}

.ship-card-row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.ship-icon.small {
  width: 32px;
  height: 32px;
  padding: 4px;
  background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(74, 144, 226, 0.2);
  flex-shrink: 0;
}

.ship-card-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.ship-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.ship-name {
  font-size: 15px;
  font-weight: 700;
  color: #1a365d;
  margin-bottom: 8px;
  word-break: break-word;
}

.ship-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.ship-status.active {
  background: rgba(34, 197, 94, 0.15);
  color: #166534;
}

.ship-status.inactive {
  background: rgba(239, 68, 68, 0.15);
  color: #991b1b;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  position: absolute;
  right: 1rem;
}

.status-dot.active {
  background: #22c55e;
  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.3);
}

.status-dot.inactive {
  background: #ef4444;
  box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.3);
}

.ship-date {
  background: linear-gradient(135deg, rgba(74, 144, 226, 0.1) 0%, rgba(53, 122, 189, 0.1) 100%);
  padding: 16px;
  border-radius: 12px;
  border: 1px solid rgba(74, 144, 226, 0.2);
  width: 100%;
}

.ship-date.compact {
  display: flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, rgba(74, 144, 226, 0.07) 0%, rgba(53, 122, 189, 0.07) 100%);
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid rgba(74, 144, 226, 0.13);
  font-size: 13px;
  margin-bottom: 0;
}

.date-label {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.date-value {
  font-size: 13px;
  color: #1e293b;
  font-weight: 600;
}

.date-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

/* Responsive */
@media (max-width: 768px) {
  .fleet-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .fleet-stats {
    align-self: stretch;
    justify-content: space-around;
  }

  .ships-cards {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 16px;
  }

  .ship-card {
    padding: 20px;
  }

  .ship-icon {
    width: 48px;
    height: 48px;
    padding: 8px;
  }
}

@media (max-width: 480px) {
  .fleet-header {
    padding: 20px;
  }

  .fleet-icon {
    width: 56px;
    height: 56px;
    padding: 12px;
  }

  .fleet-title {
    font-size: 24px;
  }

  .fleet-subtitle {
    font-size: 14px;
  }

  .ships-cards {
    grid-template-columns: 1fr;
  }
}
</style>